import PropTypes from "prop-types";
import { Link as RouterLink } from "react-router-dom";
import { styled } from "@mui/material/styles";
import { Box, Link, Typography } from "@mui/material";
import { PATH_DASHBOARD } from "../../../routes/paths";
import Iconify from "src/components/Iconify";

const RootStyle = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(2, 2.5),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: theme.palette.info.lighter,
  transition: theme.transitions.create("opacity", {
    duration: theme.transitions.duration.shorter,
  }),
}));

NavbarUsers.propTypes = {
  isCollapse: PropTypes.bool,
};

export default function NavbarUsers({ isCollapse }) {
  const teamId = localStorage.getItem("teamId");
  const teamName = localStorage.getItem("teamName");

  return (
    <Link
      underline="none"
      color="inherit"
      component={RouterLink}
      to={PATH_DASHBOARD.teams.manageTeam(teamId)}
    >
      <RootStyle
        sx={{
          ...(isCollapse && {
            bgcolor: "transparent",
          }),
        }}
      >
        <Iconify icon={"mdi:user-group"} width={35} height={35} />

        <Box
          sx={{
            ml: 2,
            transition: (theme) =>
              theme.transitions.create("width", {
                duration: theme.transitions.duration.shorter,
              }),
            ...(isCollapse && {
              ml: 0,
              width: 0,
            }),
          }}
        >
          <Typography variant="subtitle1" noWrap>
            Team Users
          </Typography>
          {teamName !== null && (
            <Typography variant="body2" noWrap sx={{ color: "text.secondary" }}>
              {teamName}
            </Typography>
          )}
        </Box>
      </RootStyle>
    </Link>
  );
}
